import moment from "moment"
import { DATE_FORMAT } from "./constant"

export const createURL = (url: string, params: any) => {
    Object.keys(params).map((param) => {
        url = url.replace(`:${param}`, params[param])
    })
    return url
}


export const UpdateWithVariables = (url: string, data: any) => {
    if (data) {
        let dynamicParams = url.match(/:[A-Z_]*/gi)
        dynamicParams?.map(key => {
            if (key.length > 1) url = url.replace(key, data[key.replace(':', '')])
        })
    }
    return url
}

export function CheckNumber(e: { target: { value: string; getAttribute: (arg0: string) => string } }) {
    let n = e.target.value.replace(/^0+/, '').replace(/[^\d.]/g, '')
    const min: number = parseFloat(e.target.getAttribute('min'))
    const max: number = parseFloat(e.target.getAttribute('max'))
    if (n == '') {
        n = '0'
    }
    if (min && parseFloat(n) < min) {
        n = String(min)
    }

    if (max && parseFloat(n) > max) {
        n = String(max)
    }
    e.target.value = n
}

export const showDate = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return (dbDate !== '') ? moment(dbDate).format(dateFormat) : "";
}
export const showLocalDate = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return dbDate ? moment.utc(dbDate).local().format(dateFormat) : "-";
}

export const showLocalTime = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return dbDate ? moment.utc(dbDate).local().format('hh:mm A') : "-";
}

export const showLocalDateTime = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return dbDate ? moment.utc(dbDate).local().format(dateFormat) + ' ' + moment.utc(dbDate).local().format('hh:mm A') : "-";
}


export const localDate = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return dbDate ? moment.utc(dbDate).local().toDate() : undefined;
}
export const localTime = (dbDate: any, dateFormat: any = DATE_FORMAT) => {
    return dbDate ? moment.utc(dbDate).local() : undefined;
}

export const getSelectedOption = (selectedValue: string | number, options: any[], matchWidth: string = 'value') => {
    let selected: any = null
    options?.map((option: any, i: number) => {
        if (option[matchWidth] == selectedValue) {
            if (!selected)
                selected = option
        }
    })
    return selected
}
export const getSelectedOptions = (selectedValues: string[] | number[] | null, options: any[]) => {
    const selected: any[] = []
    selectedValues?.map((value) => {
        selected.push(getSelectedOption(value, options))
    })
    return selected
}

export const downloadExcel = (data: any, fileName: string) => {
    const blob = new Blob([data], { type: 'application/vnd.ms-excel ' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
}
export const downloadPDF = (data: any, fileName: string) => {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName + '.pdf';
    a.click();
    window.URL.revokeObjectURL(url);
}

export const getPermissionInfo = (url: string = `/`, entity_name: string = ``, loggedinuser: any): boolean => {
    
    const slugify = (str: string) => str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    // admin user => always true
    if (loggedinuser?.userTypeID !== 1) {
        // find matching module
        console.log("get mod", loggedinuser.module);
        const module = loggedinuser.module.find((m: any) => {
            if (!m.url) return false;
            if (m.url.endsWith("^")) {
                const baseUrl = m.url.replace("^", "");
                return url === baseUrl || url.startsWith(baseUrl + "/");
            }
            return url === m.url;
        });
        

        if (module) {
            console.log("under module");
            if (module.entity.length > 0) {
                const entityRow = module.entity.find(
                    (e: any) => slugify(e.obj) === slugify(entity_name)
                );

                if (entityRow) {
                    const hasPermission = entityRow.r === 1 || entityRow.w === 1 || entityRow.d === 1;
                    if (hasPermission) return true;
                }
                // if no specific entity found, check if all permissions are zero
                // not remove this portion
                /* const allZero = module.entity.every(
                    (e: any) => e.r === 0 && e.w === 0 && e.d === 0
                );
                if (allZero) return true; */

                return false;
            } else {
                return true;
            }

        }
    }
    return true;   // admin always allowed
};
